export default {
  jurisdictionsPerTokenCountries: state => state.jurisdictionsPerTokenCountries,
  totalTokenCountriesCount: state => state.totalTokenCountriesCount,
  jurisdictionsPerTokenStatesAndRegions: state => state.jurisdictionsPerTokenStatesAndRegions,
  totalTokenStatesAndRegionsCount: state => state.totalTokenStatesAndRegionsCount,
  editableTokenCountry: state => state.editableTokenCountry,
};
